import { render, staticRenderFns } from "./Toolbar.vue?vue&type=template&id=21c038c4"
import script from "./Toolbar.vue?vue&type=script&lang=js"
export * from "./Toolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports